/** Case- and accent-insensitive; every word of the query must appear in the label. */
export function matchesQuery(label: string, query: string): boolean {
  const fold = (s: string) =>
    s
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[_/]/g, ' ')
      .toLowerCase()
      .replace(/đ/g, 'd')
  const haystack = fold(label)
  return fold(query)
    .split(/\s+/)
    .filter(Boolean)
    .every((word) => haystack.includes(word))
}
